import { productConstants } from "../constants/ActionTypes";

const initialState = {
  products: [],
};

const product = (state = initialState, { type, payload }) => {
  switch (type) {
    case productConstants.GET_PRODUCTS_ALL:
      return { ...state, products: payload };
    default:
      return state;
  }
};

export default product;
